var map = {
	"./articles.de-CH.json": 1363,
	"./articles.de-DE.json": 1364,
	"./articles.en-CA.json": 1365,
	"./articles.en-GB.json": 1366,
	"./articles.en-IN.json": 1367,
	"./articles.en-ME.json": 1368,
	"./articles.en-US.json": 1369,
	"./articles.es-EM.json": 1370,
	"./articles.es-ES.json": 1371,
	"./articles.fr-BE.json": 1372,
	"./articles.fr-CA.json": 1373,
	"./articles.fr-CH.json": 1374,
	"./articles.nl-BE.json": 1375,
	"./articles.nl-NL.json": 1376,
	"./articles.pl-PL.json": 1377,
	"./articles.pt-BR.json": 1378
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1362;